export default function Hero() {
  return (
    <section className="relative min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Bright%20airy%20modern%20lifestyle%20photography%20background%20featuring%20an%20artistic%20top%20down%20arrangement%20of%20fashion%20accessories%20sneakers%20bags%20watches%20and%20small%20decorative%20objects%20scattered%20across%20a%20light%20sand%20colored%20linen%20textile%20surface%2C%20soft%20diffused%20natural%20window%20light%20from%20upper%20left%2C%20warm%20earthy%20tone%20palette%20with%20subtle%20sage%20green%20accents%2C%20editorial%20minimalism%20with%20organic%20negative%20space%2C%20sophisticated%20yet%20approachable%20composition&width=1800&height=1200&seq=hero-bg-v2-lifestyle&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/30 via-background-50/10 to-background-50/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full mb-6 md:mb-8 animate-fade-in">
            <i className="ri-sparkling-2-line text-primary-500 text-sm"></i>
            <span className="text-xs md:text-sm font-medium text-foreground-600">
              Updated Daily · 15,000+ Curated Finds
            </span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight mb-5 md:mb-6 animate-fade-in-up">
            The Ultimate
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-400">
              Kakobuy Spreadsheet
            </span>
            <br />
            Hub For Smart Shopping
          </h1>

          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            Discover thousands of organized product finds, verified shopping lists, comparison guides, and updated spreadsheets designed to help you find better products faster.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.25s' }}>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              Explore Kakobuy Sheet
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-foreground-800 rounded-full text-sm font-semibold hover:bg-background-100 transition-all border border-background-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              Browse Categories
              <i className="ri-arrow-down-line text-sm"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10 md:mt-12 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-full">
                <i className="ri-check-line text-accent-600 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-500">Updated Product Lists</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-full">
                <i className="ri-check-line text-accent-600 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-500">Community Curated Finds</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-full">
                <i className="ri-check-line text-accent-600 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-500">Detailed Comparison Guides</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-full">
                <i className="ri-check-line text-accent-600 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-500">Safe Shopping Resources</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float cursor-pointer">
        <a href="#categories" className="flex flex-col items-center gap-1 text-foreground-400 hover:text-foreground-600 transition-colors">
          <span className="text-xs font-medium">Scroll to explore</span>
          <i className="ri-arrow-down-s-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}